module.exports = __webpack_public_path__ + "static/media/play-button.ea6ad697.svg";